import React from 'react';
import { AdminBadge } from '../chat/AdminBadge';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../ui/tooltip';

export const TipSender = ({ notice, prefix, onClick }) => {
  const name = notice.sender_name || 'Unknown sender';
  const Name = onClick ? 'button' : 'strong';
  return <span className="tip-sender-identity" data-testid={`${prefix}-identity-${notice.id}`}>
    {notice.sender_is_admin && <AdminBadge testid={`${prefix}-admin-${notice.id}`} />}
    <TooltipProvider delayDuration={150}><Tooltip><TooltipTrigger asChild>
      <Name className="tip-sender-name" data-testid={`${prefix}-sender-${notice.id}`} title={name} {...(onClick ? { type: 'button', onClick } : { tabIndex: 0 })}>{name}</Name>
    </TooltipTrigger><TooltipContent className="tip-sender-tooltip" data-testid={`${prefix}-sender-tooltip-${notice.id}`}>{name}</TooltipContent></Tooltip></TooltipProvider>
  </span>;
};